<table mat-table [dataSource]="data" class="mat-elevation-z8" matSort
(matSortChange)="sortData($event)" >
    <ng-container *ngFor="let col of columns">
        <ng-container matColumnDef="{{col.name}}" *ngIf="col.name == 'controls'">
            <th mat-header-cell *matHeaderCellDef title="{{col.name}}" class="controls"> {{col.title}}</th>
            <td mat-cell *matCellDef="let element; let i=index" class="controls">
                <span style="display: flex; flex-direction: row; justify-content: space-evenly">
                    <i class="fa fa-{{control.icon}} ico__color" [ngClass]="{'disabled-icon': control.canBeDisabled && element[control.disabledField]}" title="{{element[control.disabledField] ? control.disabledTitle : control.title}}" (click)="!element[control.disabledField] && onControlClick(element, control.action)" aria-hidden="true" *ngFor="let control of controls; let j=index">
                    </i>
                </span>
            </td>
        </ng-container>
        <ng-container matColumnDef="{{col.name}}" *ngIf="col.name == 'buttons'">
            <th mat-header-cell *matHeaderCellDef title="{{col.title}}">{{col.title}}</th>
            <td mat-cell *matCellDef="let element; let i=index">
                <ng-container *ngIf="col.type == AppSettings.TOGGLE">
                    <input type="checkbox" id="toggle-{{i}}" [(ngModel)]="element.checked"
                    (ngModelChange)="onButtonClick(element, i, col, $event)" [disabled]="element.disabled" />
                    <label class="toggle-label" for="toggle-{{i}}" title="{{element.checked ? 'Active': 'Inactive'}}"></label>
                </ng-container>
            </td>
        </ng-container>
        <ng-container matColumnDef="{{col.name}}" *ngIf="col.name != 'controls' && col.name != 'buttons'" >
            <ng-container *ngIf="col.isSortField">
                <th mat-header-cell *matHeaderCellDef mat-sort-header title="{{col.title}}" class="column-content" >{{col.title}}</th>
            </ng-container>
            <ng-container *ngIf="!col.isSortField">
                <th mat-header-cell *matHeaderCellDef title="{{col.title}}" class="column-content" >{{col.title}}</th>
            </ng-container>
            <td mat-cell *matCellDef="let element" class="column-content">
                <span  title="{{element[col.name]}}">
                    {{ element[col.name] }}
                </span>
            </td>
        </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnHeders"></tr>
    <tr mat-row *matRowDef="let row; columns: columnHeders"></tr>
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="columnHeders?.length ? columnHeders.length : 1" style="text-align: center">
          No data found
        </td>
      </tr>
</table>
<mat-paginator (page)="pageChanged($event)" [pageSize]="pageSize"  [showFirstLastButtons]="true" [length]="totalRec"  [pageIndex]="pageNo"></mat-paginator>